import { Text } from '@chakra-ui/react'
import { Dispatch, SetStateAction } from 'react'

import { FaqEditor } from '../FaqEditor'
import { IEventForm } from './eventFormShared'

interface IProps {
  form: IEventForm
  setForm: Dispatch<SetStateAction<IEventForm>>
  fieldErrors: Record<string, string[]>
  saving: boolean
}

export function FaqTab({ form, setForm, fieldErrors, saving }: IProps) {
  return (
    <>
      <Text variant="caption" mb={4}>
        Perguntas e respostas exibidas na página pública do evento. Quando o evento pertence a uma série, as perguntas
        da série também são exibidas, somadas às cadastradas aqui.
      </Text>
      <FaqEditor
        faqs={form.faqs}
        onChange={(next) => setForm({ ...form, faqs: next })}
        disabled={saving}
        fieldErrors={fieldErrors}
        inheritedFaqs={form.inherited_faqs}
      />
    </>
  )
}
